<template>
  <div class="c-team-popin u-fixed u-pos-tl u-viewport-fit-h u-fit-w u-vacuum " style="z-index:10000;">
     <div class="c-team-popin__content u-absolute u-pos-tl u-fit-w">
        <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-tl u-fit-w u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-bl u-fit-w u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark"></div>
     </div>
     <div class="c-team-popin__content o-wrapper--panel u-fit">
        <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-tl u-fit-w u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-br u-fit-w u-bg--brand-dark"></div>
        <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark"></div>
        <div class="o-wrapper--panel  u-fit u-overflow-h">
           <div class="u-relative u-zindex--1 u-inline-block u-valign-top u-fit-h u-w1of2 u-cover u-hide@sm" v-if="content!=null">
              <div class="u-absolute u-pos-tl u-zindex--1 u-fit u-cover"  >
                <img :src="content.image.url+'?'+getRandomNumber(200,2000)" class="c-team-popin__photo o-wrapper--panel u-fit u-object-fit-cover" id="c-team-popin__photo">
              </div>
           </div>
           <div class="o-wrapper--valign u-inline-block u-valign-top u-fit-h  u-pad-x-w1of12  u-pad-l-w1of16@xl u-pad-r-w1of16@xl u-pad-l-0@sm u-pad-r-0@sm u-bg--white u-w1of2 u-w2of2@sm " v-if="content!=null">
              <div class="u-flex u-flex-ai--center  u-flex-ai--start@sm u-fit">
                 <div class="c-team-popin__container__content   toscrollup u-force-3d u-pad-y-xxl@sm u-marg-t-ultra u-marg-t-xs@sm">
                    <h5 class="c-team-popin__container__content__name c-team-popin__line u-pad-x-w1of8@sm t-text--roman u-color--gray u-marg-b-sm  u-marg-t-xs">{{content.first_name}}</h5>
                    <h6 class="c-team-popin__line u-pad-x-w1of8@sm t-h5 u-color--gray u-marg-b-lg u-marg-b-md@sm">{{content.position}}</h6>
                    <div class="c-team-popin__line o-content u-pad-x-w1of8@sm t-text--md u-color--gray u-marg-b-md u-marg-r-sm"  v-html="content.description"></div>
                    <div class="c-team-popin__line c-team-popin__buttons u-pad-x-w1of8@sm u-align-right u-marg-b-lg">
                      <a class="t-btn t-btn--hovered t-text--sm t-text--base-bold u-relative u-color--brand-blue-dark" v-if="content.show=='true'&&content.file" :href="content.file.url" :download="content.first_name + '  ' + content.last_name" :title="download" target="_blank" rel="nofollow noopener noreferrer" @mouseenter="_onMouseenterButton"  @mouseleave="_onMouseleaveButton">  </a>
                      <a class="t-btn t-btn--hovered t-text--sm t-text--base-bold u-relative u-color--brand-blue-dark u-marg-r-w1of8" v-if="content.website!=''"   :href="content.websiteurl" :title="content.first_name+'website' " target="_blank" rel="nofollow noopener noreferrer" @mouseenter="_onMouseenterButton"  @mouseleave="_onMouseleaveButton"> {{content.website}} </a>
                    </div>
                 </div>
              </div>
           </div>
           <div class="c-team-popin__aside o-wrapper--valign u-absolute u-zindex--2 u-align-right u-bg--brand-dark u-hide@sm">
              <div class="c-team-popin__aside__content u-inline-block u-valign-middle u-marg-r-lg">
                 <div class="u-inline-block u-valign-middle">
                   <span class="t-text--xs u-inline-block u-valign-middle u-color--alpha-white u-marg-r-sm">{{title}}</span>
                    <span class="c-line c-line--x u-inline-block u-valign-middle u-bg--white u-marg-r-sm" style="width: 45px;"></span>
                     <span class="t-text--xs u-inline-block u-valign-middle u-color--alpha-white">{{"00" + (index + 1)}}</span>
                   </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</template>
<script>
import      AppScrollObject  from  '../app-scroll-object/index.vue'
import      CoreEmit from     '../core-emit/index.vue'

export default {
  name: "app-team-popin",
               props: {
                 debug: {
                   type: Boolean,
                   default: !1
               },
                   content: {
                       type: Object,
                       default: function() {}
                   },
                   isActive: {
                       type: Boolean,
                       default: !1
                   },
                   title: {
                       type: String,
                       default: ""
                   },
                   index: {
                       type: Number,
                       default: 0
                   }
               },
               data: function() {
                   return {
                       buttonHoveredIndex: null,
                       vCardLink: ""
                   }
               },
               components: {
                   "app-scroll-object":AppScrollObject,
                    "core-emit":CoreEmit
               },

               watch: {
                   isActive: "onActiveChange"
               },
               created: function()
               {
                   this.onPrintPage = this.onPrintPage.bind(this),
                   this.eventHub.$on("print:page", this.onPrintPage)
               },
               mounted: function() {


               },
               destroyed: function() {
                   this.eventHub.$off("print:page", this.onPrintPage)
               },
               methods: {
                 getRandomNumber: function(min, max) {
                      return Math.floor(Math.random() * (max -min +1)) + min;
                      },
                   onActiveChange: function()
                   {

                       this.$el.querySelector(".toscrollup").scrollTop=0,

                       this.$buttons = this.$el.querySelectorAll(".js-button-hovered"),
                       this.isActive
                       ?
                       (document.addEventListener("keydown", this._onKeydown), this.$el.classList.add("is-visible"))
                       :
                       (document.removeEventListener("keydown", this._onKeydown),  this.$el.classList.remove("is-visible"))
                   },
                   _onKeydown: function(t) {
                       27 === t.keyCode && this.eventHub.$emit("close:popin")
                   },
                   toDataURL: function(t, e)
                   {
                       var n = new XMLHttpRequest;
                       n.onload = function()
                       {
                           var t = new FileReader;
                           t.onloadend = function() {
                               e(t.result)
                           }, t.readAsDataURL(n.response)
                       }, n.open("GET", t), n.responseType = "blob", n.send()
                   },
                   onPrintPage: function() {
                       window.print()
                   },
                   _onMouseenterButton: function(t)
                   {
                       0 === t && (this.$buttons[1].style.transform = "translateX(" + (this.$buttons[t].offsetWidth - 1) + "px) translateY(0) translateZ(0)")
                   },
                   _onMouseleaveButton: function(t)
                   {
                       0 === t && (this.$buttons[1].style.transform = "translateX(0) translateY(0) translateZ(0)")
                   }
               }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/app-team-popin/index.vue